import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AccountEditorData, BPartnerBalanceData } from '@compiere-ws/models/apiz-domains';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class SpecificDataService {
  private readonly BASE = `${environment.config.backend.ws.url}/specific`;

  private readonly http = inject(HttpClient);

  //#region Account Editor Window
  getAccountEditorData<T extends AccountEditorData[]>(acctSchemaId: number): Observable<T> {
    return this.http.get<T>(this.getUrl(`account-editor-data/${acctSchemaId}`));
  }

  hasDuplicateAlias<T extends boolean>(alias: string, clientId: number): Observable<T> {
    const params = new HttpParams().set('alias', alias).set('clientId', clientId);
    return this.http.get<T>(this.getUrl('account-editor-data/duplicate'), { params });
  }
  //#endregion

  //#region BPartner Balance
  getBPartnerBalanceData<T extends BPartnerBalanceData>(partnerId: number, pieceTypeId?: string): Observable<T> {
    const params = new HttpParams().set('partnerId', partnerId).set('pieceTypeId', pieceTypeId);
    return this.http.get<T>(this.getUrl('bpartner-balance'), { params });
  }
  //#endregion

  private getUrl(url?: string): string {
    if (url) {
      return `${this.BASE}/${url}`;
    }

    return this.BASE;
  }
}
